var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Status } from "../models";
import { flattenIds } from "../utils";
import URLSearchParams from "url-search-params";
import { nonRedirectingMonsApiFetch } from "../utils/monsUtils";
var MARK_NOTIFICATION_PREFIX = "/communications/notifications";
export function toQueryString(accountInfoParams) {
    var params = new URLSearchParams();
    params.set("entityId", accountInfoParams.entityId);
    return params.toString();
}
export function markNotificationsDisplayed(notifications, accountInfoParams, placement) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _markMultiNotification(notifications, Status.DISPLAYED, accountInfoParams, placement)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function markNotificationRead(notification, accountInfoParams, placement) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _markMultiNotification([notification], Status.READ, accountInfoParams, placement)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function markSubNotificationRead(subNotification, accountInfoParams, placement, marketplaceId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                //updating by string should only be done for individual subnotifications.
                //Attempting to update an entire aggregated notification by passing its eventID to this function will lead to incorrect behavior.
                return [4 /*yield*/, _markMultiNotificationEventIds([subNotification], Status.READ, accountInfoParams, placement)];
                case 1:
                    //updating by string should only be done for individual subnotifications.
                    //Attempting to update an entire aggregated notification by passing its eventID to this function will lead to incorrect behavior.
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function markNotificationDismissed(notification, accountInfoParams, placement) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _markMultiNotification([notification], Status.DISMISSED, accountInfoParams, placement)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function _markMultiNotification(notifications, status, accountInfoParams, placement) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, _markMultiNotificationEventIdsWithMarketplaceId(flattenIds(notifications), status, accountInfoParams, placement)];
        });
    });
}
function _markMultiNotificationEventIds(eventIds, status, accountInfoParams, placement) {
    return __awaiter(this, void 0, void 0, function () {
        var url, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = MARK_NOTIFICATION_PREFIX + "?" + toQueryString(accountInfoParams);
                    body = {
                        notifications: eventIds.map(function (eventId) { return ({ eventId: eventId, status: status }); }),
                        status: status,
                        placement: placement
                    };
                    console.log("attempting mark at '" + url + "' with body: " + JSON.stringify(body));
                    return [4 /*yield*/, nonRedirectingMonsApiFetch(url, {
                            method: 'PATCH',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    if (response.status !== 204) {
                        throw new Error("Bad response status " + response.status);
                        //todo: do we want different behaviors for certain error codes
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function _markMultiNotificationEventIdsWithMarketplaceId(eventIds, status, accountInfoParams, placement) {
    return __awaiter(this, void 0, void 0, function () {
        var url, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = MARK_NOTIFICATION_PREFIX + "?" + toQueryString(accountInfoParams);
                    body = {
                        notifications: eventIds.map(function (e) { return ({
                            eventId: e.eventId,
                            marketplaceId: e.marketplaceId,
                            status: status
                        }); }),
                        status: status,
                        placement: placement
                    };
                    console.log("attempting mark at '" + url + "' with body: " + JSON.stringify(body));
                    return [4 /*yield*/, nonRedirectingMonsApiFetch(url, {
                            method: 'PATCH',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    if (response.status !== 204) {
                        throw new Error("Bad response status " + response.status);
                        //todo: do we want different behaviors for certain error codes
                    }
                    return [2 /*return*/];
            }
        });
    });
}
